/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { getMTAPreview, bindMTA, removePolicySubmit } from '../../../../actions'

/**
 * Import
 * - Page component
 */
import MTAConfirm from '../../../../components/pages/Policies/MTA/components/MTAConfirm'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        mta: state.mta.summary,
        mtaBound: state.mta.bound,
        isCollectors: get(state, 'mta.summary.response.isCollectors', false),
        isMuseums: get(state, 'mta.summary.response.isMuseums', false),
        isDealersStock: get(state, 'mta.summary.response.isDealersStock', false),
        isWineSpirits: get(state, 'mta.summary.response.isWineSpirits', false),
        mta_bound_data: state.mta.mta_bound,
    }
}

export default connect(
    mapStateToProps,
    {
        getMTAPreview,
        bindMTA,
        removePolicySubmit,
    }
)(MTAConfirm)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Policies/MTA/MTAConfirm.tsx